import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MailIcon } from '../components/Icons';
import './Auth.css';

const ConfirmationPending: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  return (
    <div className="auth-page">
      {/* Header */}
      <header className="auth-header">
        <div className="auth-header-content">
          <div className="auth-logo" onClick={() => navigate('/')}>
            <img src="/logo_transp.png" alt="ContratoSeguro" />
          </div>
          <div className="auth-header-actions">
            <button onClick={() => navigate('/')} className="btn-text">
              Voltar para o início
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="auth-main">
        <div className="auth-container">
          <div className="confirmation-pending-container">
            <div className="confirmation-card">
              <div className="confirmation-icon">
                <MailIcon size={64} />
              </div>

              <h1>Verifique seu e-mail</h1>

              <p className="confirmation-message">
                Enviamos um link de confirmação para <strong>{email}</strong>
              </p>

              <div className="confirmation-steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h3>Verifique sua caixa de entrada</h3>
                    <p>Procure por um e-mail de ContratoSeguro</p>
                  </div>
                </div>

                <div className="step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h3>Clique no link de confirmação</h3>
                    <p>O link é válido por 24 horas</p>
                  </div>
                </div>

                <div className="step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h3>Comece a usar o ContratoSeguro</h3>
                    <p>Você será automaticamente redirecionado</p>
                  </div>
                </div>
              </div>

              <div className="confirmation-help">
                <p className="help-text">Não recebeu o e-mail?</p>
                <ul>
                  <li>Verifique sua pasta de spam ou lixo eletrônico</li>
                  <li>Certifique-se de que digitou o e-mail corretamente</li>
                  <li>Aguarde alguns minutos e verifique novamente</li>
                </ul>
              </div>

              <div className="confirmation-actions">
                <button onClick={() => navigate('/login')} className="btn-secondary">
                  Voltar para o login
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="auth-footer-section">
        <div className="auth-footer-content">
          <div className="footer-left">
            <img src="/logo_transp.png" alt="ContratoSeguro" className="footer-logo-small" />
            <div className="footer-copy">
              <p className="footer-brand">ContratoSeguro</p>
              <p className="footer-tagline">Clareza para quem assina.</p>
            </div>
          </div>
          <div className="footer-center">
            <a href="/termos-de-uso">Termos de Uso</a>
            <a href="/politica-de-privacidade">Política de Privacidade</a>
            <a href="/politica-de-cookies">Política de Cookies</a>
            <a href="/aviso-legal">Aviso Legal</a>
          </div>
          <div className="footer-right">
            <p className="footer-heading">Contato</p>
            <p className="footer-contact">suporte@contratoseguro.com.br</p>
            <p className="footer-heading">LGPD</p>
            <p className="footer-contact">privacidade@contratoseguro.com.br</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ConfirmationPending;
